import { Link } from 'react-router-dom';
import { useBrand } from '../lib/brand';
import { MarketingShell, SectionHeading, usePageMeta } from './chrome';
import { comparisonRows, faqs, nzd, pricingIntro, pricingNotes, pricingTiers } from './content';

export default function PricingPage() {
  const brand = useBrand();
  usePageMeta(`Pricing · ${brand.name}`, pricingIntro.sub);

  return (
    <MarketingShell>
      <section className="mkt-band mkt-band-tide" data-mkt-surface="dark">
        <div className="px-6 py-mkt-sm md:py-mkt">
        <SectionHeading level="h1" tone="light" title={pricingIntro.title} sub={pricingIntro.sub} />
        <h2 className="sr-only">Plans</h2>
        <ul className="mx-auto mt-12 grid max-w-[1100px] gap-5 lg:grid-cols-3">
          {pricingTiers.map((tier) => (
            <li key={tier.id} className={`mkt-card flex flex-col px-6 py-8 ${tier.highlighted ? 'ring-4 ring-[#00AAA4]' : ''}`}>
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="text-[21px] font-semibold">{tier.name}</h3>
                {tier.highlighted ? <span className="text-[14px] text-mkt-teal">Most clubs</span> : null}
              </div>
              <p className="mt-2 text-mkt-body text-mkt-secondary">{tier.tagline}</p>
              <p className="mt-6 text-mkt-section-sm tracking-tight">
                {nzd(tier.priceMonthly)}
                <span className="text-mkt-body text-mkt-secondary"> / month</span>
              </p>
              <p className="mt-1 text-mkt-body text-mkt-secondary">{nzd(tier.priceYearly)} a year, GST included</p>
              <ul className="mt-6 space-y-2 text-mkt-body">
                <li>{tier.swimmers}</li>
                <li>{tier.seats}</li>
                <li>{tier.pools}</li>
              </ul>
              <ul className="mt-6 flex-1 space-y-2 border-t border-mkt-line pt-6 text-mkt-body text-mkt-secondary">
                {tier.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <Link
                to={`/contact?plan=${tier.id}`}
                className="mt-8 inline-flex h-11 items-center justify-center rounded-full bg-mkt-accent px-6 text-mkt-body text-white hover:bg-mkt-accent-hover"
              >
                {tier.cta}
              </Link>
            </li>
          ))}
        </ul>
        </div>
      </section>

      <section className="mkt-band mkt-band-pool" data-mkt-surface="dark">
        <div className="px-6 py-mkt-sm md:py-mkt">
        <h2 className="text-mkt-section-sm text-white">Compare plans</h2>
        <div className="mkt-card mx-auto mt-8 max-w-[1100px] overflow-x-auto p-4 md:p-6">
          <table className="w-full min-w-[720px] border-collapse text-left text-mkt-body text-mkt-ink">
            <caption className="sr-only">Compare plans</caption>
            <thead>
              <tr className="border-b border-mkt-line">
                <th scope="col" className="py-3 pr-4 font-semibold">
                  <span className="sr-only">Feature</span>
                </th>
                {pricingTiers.map((tier) => (
                  <th key={tier.id} scope="col" className="py-3 pr-4 font-semibold">
                    {tier.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row) => (
                <tr key={row.label} className="border-b border-mkt-line">
                  <th scope="row" className="py-3 pr-4 font-normal text-mkt-secondary">
                    {row.label}
                  </th>
                  <td className="py-3 pr-4">{row.solo}</td>
                  <td className="py-3 pr-4">{row.pro}</td>
                  <td className="py-3 pr-4">{row.enterprise}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <ul className="mx-auto mt-8 max-w-[1100px] space-y-3 text-mkt-body text-white">
          {pricingNotes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
        </div>
      </section>

      <section className="mkt-band mkt-band-deep" data-mkt-surface="dark">
        <div className="mx-auto max-w-[800px] px-6 py-mkt-sm md:py-mkt">
          <h2 className="text-mkt-section-sm text-white">Questions</h2>
          <div className="mt-8 space-y-3">
            {faqs.map((item) => (
              <details key={item.q} className="mkt-card px-5 py-4">
                <summary className="cursor-pointer text-mkt-body font-semibold text-mkt-ink">{item.q}</summary>
                <p className="mt-3 text-mkt-body text-mkt-ink">{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
